var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArenan = function SvgArenan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1352 350",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#29CCDE",
    d: "M449.5 300h452v50h-452z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M222.8 200 293.6 0h47.5l69.5 200h-43.7l-18.7-52.9H281L262.9 200zM340 117l-24.4-76.9-25.8 76.9z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M781.5 200h38.7V67l101.9 133h29.4V0h-39v126.5L817.7 0h-36.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "m500.9 132.5 44.2 67.5h46.7l-51.6-74.7c18.1-8 43.4-25.7 43.4-66.9C583.6 18 552.8 0 501.5 0c-44.8 0-69.7 6.9-69.7 6.9V200h39v-67.5zm14-31.3h-44.2V34.9s15.4-2.8 31.3-2.8c25.3 0 40.6 8.6 40.6 30.2.1 20.7-8.7 30.9-27.7 38.9",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M614.9 200V0h133.7v33.9h-94.5v50.2h81.6v32.5h-81.6V166H751v34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M1030.6 147.1h67.3l18.7 52.9h43.7L1090.7 0h-47.5l-70.8 200h40.1zm8.7-30.1 25.8-76.9 24.4 76.9zM200 9.3v181.4c0 5-4.3 9.3-9 9.3H9.4c-5.1 0-9.4-4.3-9.4-9.3V9.3C0 4.1 4.3 0 9.4 0H191c4.7 0 9 4.1 9 9.3m-98.3 32.9h-8.2c-1.5 0-6 0-6 4.5v3.6c0 1.4.6 4.7 6.4 4.7h1.4v67.2c0 3.8.9 6.2 5.3 6.2h2.7c4.5 0 5.1-3.1 5.1-6.2V51.6c-.1-3.5-.1-9.4-6.7-9.4m62.9 73.6c-.8 0-1.7.2-2.7.4l-.4.1c-2 .4-5.4 1.1-10.8 1.1-13.9 0-15.5-2.4-15.9-13.2h26.5c6.1 0 8.8-2.4 8.8-7.8 0-11.4-2.4-26.7-23.2-26.7-17.6 0-25.4 9.5-25.4 30.9 0 20.9 7.3 28.6 26.9 28.6 8.2 0 14.6-1.3 17.1-2.4 1.6-.7 3.1-1.7 3.1-4.6v-2.1c.2-2.7-1.4-4.3-4-4.3M74.3 71.2h3.2c2.8 0 4.7 1.9 4.7 4.7 0 2.2-1.1 6.5-1.2 6.9-.4 1.8-10.5 44-14.2 57.9-2.2 8.1-8.9 13-17.9 13-8.8 0-11.8-.6-14.2-1.7-1.6-.7-3.1-1.7-3.1-4.6v-2.3c0-2.7 1.5-4.3 4.1-4.3.8 0 1.6.1 2.7.2h.30000000000000004c1.8.2 4.4.5 8.3.5 4.4 0 7-1 8.7-6.2.4-1.3 1.1-4.6 1.7-7.5h-4.2c-6.8 0-10.6-3-12.4-9.8L31 83.6c-.9-3.6-1.4-6-1.4-7.7 0-3 1.8-4.7 4.9-4.7h3.4c3.6 0 4.4 3 5.1 5.6l.1.4 9.1 34.5c1.1 4.3 2.6 4.8 5.9 4.6h1.5l9-39.1c1-3.8 2.2-6 5.7-6m72.9 8.8c-8 0-11.8 4.2-12.3 13.5h23.6c-.3-9.4-3.7-13.5-11.3-13.5",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1181 200.1h38.7v-133l101.9 133h29.4V.1h-39v126.5L1217.3.1H1181z"
  })));
};
export default SvgArenan;